const withSavedOption = (options, value) => {
  if (!value) return options;
  if (options.some((option) => option.value === value)) return options;
  return [{ value, label: value }, ...options];
};

export default withSavedOption;
